(function () {
  'use strict';

  const { iman, ProductForms, SingleProduct, BaseCarousel, GalleryCard, QuickAdd, HoverZoom, Lightbox } = window.Universe;


  class ProductTemplateManager {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.templateContainers.length; i++) {
        this.templateInstances.push(new SingleProduct(this.DOM.templateContainers[i]));
      }
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.templateInstances.length; i++) {
          this.templateInstances[i].destroy();
        }
        this.templateInstances = [];
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    reinitSection(sectionEl) {
      this.destroySection(sectionEl);

      const templateContainers = sectionEl.querySelectorAll('.js-product-template-section');
      if (templateContainers.length) {
        if (!this.DOM) {
          this.DOM = {};
          this.templateInstances = [];
        }
        for (let i = 0; i < templateContainers.length; i++) {
          this.templateInstances.push(new SingleProduct(templateContainers[i]));
        }
        this.DOM.templateContainers = document.querySelectorAll('.js-product-template-section');
      }

      if (!iman.get('productForms')) {
        iman.add('productForms', new ProductForms());
      }
      iman.get('lightbox')?.destroy();
      iman.add('lightbox', new Lightbox());
    }

    destroySection(sectionEl) {
      if (!this.templateInstances || !this.DOM) return;

      const containersInSection = Array.from(sectionEl.querySelectorAll('.js-product-template-section'));
      if (!containersInSection.length) return;

      const allContainers = Array.from(this.DOM.templateContainers);
      const survivingInstances = [];

      for (let i = 0; i < this.templateInstances.length; i++) {
        if (containersInSection.includes(allContainers[i])) {
          this.templateInstances[i].destroy();
        } else {
          survivingInstances.push(this.templateInstances[i]);
        }
      }

      this.templateInstances = survivingInstances;
      this.DOM.templateContainers = document.querySelectorAll('.js-product-template-section');
    }

    init(container = document) {
      const templateContainers = container.querySelectorAll('.js-product-template-section');

      if (templateContainers.length) {
        this.DOM = {};
        this.DOM.templateContainers = templateContainers;

        this.templateInstances = [];

        this.setup();
      }
    }
  }


  class RelatedProducts {
    constructor() {
      this.init();
    }

    setup() {
      for (let i = 0; i < this.DOM.sections.length; i++) {
        this.instances.push(new RelatedProduct(this.DOM.sections[i]));
      }
    }

    reinit() {
      this.destroy();
      this.init();
    }

    destroy() {
      if (this.DOM) {
        for (let i = 0; i < this.instances.length; i++) {
          this.instances[i].destroy();
        }
        this.instances = [];
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const sections = container.querySelectorAll('.js-related-products');

      if (sections.length) {
        this.DOM = {};
        this.DOM.sections = sections;

        this.instances = [];

        this.setup();
      }
    }
  }


  class RelatedProduct {
    constructor(parent) {
      this.onPrev = () => {
        this.instance.instance.scrollPrev();
      };

      this.onNext = () => {
        this.instance.instance.scrollNext();
      };

      if (!parent) return;
      this.init(parent);
    }

    setup() {
      const isMobileEnabled = this.DOM.section.dataset.mobileEnabled;
      const isDesktopEnabled = this.DOM.section.dataset.desktopEnabled;

      this.instance = new BaseCarousel({
        wrap: this.DOM.parent,
        carousel: this.DOM.section,
        carouselOptions: {
          containScroll: 'trimSnaps',
          dragFree: true,
          align: 'start',
          loop: false,
          active: isDesktopEnabled === 'true',
          breakpoints: {
            '(max-width:768px)': { active: isMobileEnabled === 'true' },
          },
        },
        onReady: () => {
          if (this.DOM.prev.length) {
            for (let i = 0; i < this.DOM.prev.length; i++) {
              this.DOM.prev[i].addEventListener('click', this.onPrev);
            }
          }

          if (this.DOM.next.length) {
            for (let i = 0; i < this.DOM.next.length; i++) {
              this.DOM.next[i].addEventListener('click', this.onNext);
            }
          }

          this.setupCards();
        },
      });
    }

    setupCards() {
      this.DOM.cards = this.DOM.parent.querySelectorAll('.js-gallery-card');
      this.DOM.quickAdd = document.querySelector('.js-quick-add-container');

      if (this.DOM.cards) {
        this.cards = [];
        this.quickAdds = [];

        this.DOM.cards.forEach((card) => {
          const cardInstance = new GalleryCard(card);
          this.cards.push(cardInstance);

          if (this.DOM.quickAdd) {
            const cardQuickAdd = new QuickAdd(card, this.DOM.quickAdd);
            this.quickAdds.push(cardQuickAdd);
          }
        });
      }
    }

    destroyCards() {
      if (this.cards) {
        this.cards.forEach((card) => { card.destroy(); });
      }
      if (this.quickAdds) {
        this.quickAdds.forEach((quickAdd) => { quickAdd.destroy(); });
      }

      this.cards = undefined;
      this.quickAdds = undefined;
      this.DOM.cards = undefined;
      this.DOM.quickAdds = undefined;
    }

    destroy() {
      if (this.DOM) {
        if (this.DOM.prev.length) {
          for (let i = 0; i < this.DOM.prev.length; i++) {
            this.DOM.prev[i].removeEventListener('click', this.onPrev);
          }
        }

        if (this.DOM.next.length) {
          for (let i = 0; i < this.DOM.next.length; i++) {
            this.DOM.next[i].removeEventListener('click', this.onNext);
          }
        }

        if (this.instance) this.instance.destroy();
        this.destroyCards();

        this.instance = undefined;
        this.DOM = undefined;
      }
    }

    init(parent) {
      this.DOM = {};
      this.DOM.parent = parent;

      this.DOM.section = this.DOM.parent.querySelector('.js-related-products-carousel');
      this.DOM.cards = this.DOM.section.querySelectorAll('.js-carousel-slide');
      this.DOM.quickAdd = document.querySelector('.js-quick-add-container');

      this.DOM.prev = this.DOM.parent.querySelectorAll('.js-carousel-prev');
      this.DOM.next = this.DOM.parent.querySelectorAll('.js-carousel-next');
      const url = this.DOM.section.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          // Safe: content from same-origin Shopify recommendations endpoint
          html.innerHTML = text;
          const recommendations = html.querySelector('.js-related-products-carousel');

          if (recommendations && recommendations.innerHTML.trim().length) {
            // Safe: same-origin Shopify content
            this.DOM.section.innerHTML = recommendations.innerHTML;
            this.setup();
          } else {
            this.DOM.parent.hidden = true;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }


  function init() {
    if (!iman.get('productForms')) {
      iman.add('productForms', new ProductForms());
    }
    if (!iman.get('productTemplateManager')) {
      iman.add('productTemplateManager', new ProductTemplateManager());
    }
    if (!iman.get('hoverZoom')) {
      iman.add('hoverZoom', new HoverZoom());
    }
    if (!iman.get('lightbox')) {
      iman.add('lightbox', new Lightbox());
    }
    if (!iman.get('relatedProducts')) {
      iman.add('relatedProducts', new RelatedProducts());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.ProductTemplateManager = ProductTemplateManager;
  window.Universe.RelatedProducts = RelatedProducts;
})();
